"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetStreaming = exports.resetNote = exports.resetShareState = exports.resetSelectedFileIds = exports.resetDocumentStreaming = exports.resetDocumentJson = exports.resetDocumentSummary = exports.resetDocuments = exports.closeDocumentPanels = exports.togglePdfOpen = exports.toggleAudioConfigOpen = exports.toggleSourcesOpen = exports.toggleDocumentConversationOpen = exports.unSelectedFile = exports.selectFiles = exports.upsertDocumentJson = exports.deleteDocumentSourcesLoading = exports.deleteDocument = exports.patchLatestDocumentCharacter = exports.patchDocumentJson = exports.patchDocumentSummary = exports.patchDocumentConversation = exports.patchDocumentCharacter = exports.patchDocument = exports.addDocumentSourcesLoading = exports.addDocument = exports.setIsAudioConfigOpen = exports.setIsSourcesOpen = exports.setIsConversationOpen = exports.setIsImageRegenerating = exports.setIsLoading = exports.setDocumentSharingType = exports.setIsDocumentSharing = exports.setDocumentShareState = exports.setDocumentUploadComplete = exports.setDocumentStreaming = exports.setNote = exports.setSelectedFileIds = exports.setDocumentJson = exports.setDocumentSummary = exports.shareDocument = exports.fetchMyDocuments = exports.documentSlice = void 0;
exports.selectWasDocumentsFetched = selectWasDocumentsFetched;
exports.selectMyDocumentsIds = selectMyDocumentsIds;
exports.selectDocumentById = selectDocumentById;
exports.selectLastDocument = selectLastDocument;
exports.selectDocumentsQuantity = selectDocumentsQuantity;
exports.selectDocumentsEntities = selectDocumentsEntities;
const toolkit_1 = require("@reduxjs/toolkit");
const document_1 = require("../services/document");
const error_1 = require("../common/error");
;
;
;
;
const documentsAdapter = (0, toolkit_1.createEntityAdapter)({
    selectId: (document) => document.character.id,
    sortComparer: (next, prev) => Number(prev.character.id) - Number(next.character.id),
});
const initialState = documentsAdapter.getInitialState({
    documentsSourcesLoading: [],
    wasDocumentsFetched: false,
    isConversationOpen: false,
    isSourcesOpen: false,
    isAudioConfigOpen: false,
    isPdfOpen: false,
    isLoading: false,
    isImageRegenerating: false,
    shareState: {
        isSharing: false,
        shareUrl: "",
        documentId: "",
        sharingType: "public"
    },
});
exports.documentSlice = (0, toolkit_1.createSlice)({
    name: 'document',
    initialState,
    reducers: {
        setIsConversationOpen(state, { payload }) {
            state.isConversationOpen = payload;
        },
        setIsSourcesOpen(state, { payload }) {
            state.isSourcesOpen = payload;
        },
        setIsAudioConfigOpen(state, { payload }) {
            state.isAudioConfigOpen = payload;
        },
        setDocumentSummary(state, { payload }) {
            state.summary = payload;
        },
        setDocumentJson(state, { payload }) {
            if (payload.character_id !== state.documentJson?.character_id) {
                state.documentJson = payload;
            }
        },
        setSelectedFileIds(state, { payload }) {
            state.selectedFileIds = payload;
        },
        setNote(state, { payload }) {
            state.note = payload;
        },
        setDocumentStreaming(state, { payload }) {
            state.streaming = payload;
        },
        setDocumentUploadComplete(state, { payload }) {
            state.documentUploadComplete = payload;
        },
        setDocumentShareState(state, { payload }) {
            state.shareState = payload;
        },
        setIsDocumentSharing(state, { payload }) {
            state.shareState.isSharing = payload;
        },
        setDocumentSharingType(state, { payload }) {
            state.shareState.sharingType = payload;
        },
        setIsLoading(state, { payload }) {
            state.isLoading = payload;
        },
        setIsImageRegenerating(state, { payload }) {
            state.isImageRegenerating = payload;
        },
        addDocument: documentsAdapter.addOne,
        addDocumentSourcesLoading(state, { payload }) {
            state.documentsSourcesLoading.push(payload);
        },
        patchDocument: documentsAdapter.updateOne,
        patchDocumentCharacter(state, { payload: { id, changes } }) {
            if (state.entities[id]) {
                state.entities[id].character = {
                    ...state.entities[id].character,
                    ...changes,
                };
            }
        },
        patchDocumentConversation(state, { payload: { id, changes } }) {
            if (state.entities[id]) {
                state.entities[id].conversation = {
                    ...state.entities[id].conversation,
                    ...changes,
                };
            }
        },
        patchDocumentSummary(state, { payload: { id, changes } }) {
            if (state.entities[id]?.character.summary) {
                state.entities[id].character.summary = {
                    ...state.entities[id].character.summary,
                    ...changes,
                };
            }
        },
        patchDocumentJson(state, { payload }) {
            if (state.documentJson?.character_id === payload.character_id) {
                state.documentJson = state.documentJson && { ...state.documentJson, ...payload };
            }
            ;
        },
        patchLatestDocumentCharacter: (state, { payload }) => {
            const latestDocument = state.entities[state.ids[0]];
            if (latestDocument) {
                latestDocument.character = { ...latestDocument.character, ...payload };
            }
            ;
        },
        deleteDocument: documentsAdapter.removeOne,
        deleteDocumentSourcesLoading(state, { payload }) {
            state.documentsSourcesLoading = (state.documentsSourcesLoading.filter((documentId) => documentId !== payload));
        },
        upsertDocumentJson(state, { payload }) {
            if (!state.documentJson
                || payload.character_id === state.documentJson.character_id
                || 'shareId' in state.documentJson
                    && (state.entities[payload.character_id]?.character.createdByShareId === state.documentJson.shareId)) {
                state.documentJson = payload;
            }
        },
        selectFiles(state, { payload }) {
            if (Array.isArray(payload)) {
                state.selectedFileIds?.push(...payload.map((file) => file.id));
            }
            else {
                state.selectedFileIds?.push(payload.id);
            }
            ;
        },
        unSelectedFile(state, { payload }) {
            state.selectedFileIds = state.selectedFileIds?.filter((fileId) => fileId !== payload.id);
        },
        toggleDocumentConversationOpen(state) {
            state.isConversationOpen = !state.isConversationOpen;
            state.isPdfOpen = false;
        },
        toggleSourcesOpen(state) {
            state.isSourcesOpen = !state.isSourcesOpen;
        },
        toggleAudioConfigOpen(state) {
            state.isAudioConfigOpen = !state.isAudioConfigOpen;
        },
        togglePdfOpen(state) {
            state.isPdfOpen = !state.isPdfOpen;
            state.isConversationOpen = false;
        },
        closeDocumentPanels(state) {
            state.isConversationOpen = false;
            state.isPdfOpen = false;
        },
        resetDocuments(state) {
            state.wasDocumentsFetched = false;
            documentsAdapter.removeAll(state);
        },
        resetDocumentSummary(state) {
            state.summary = initialState.summary;
        },
        resetDocumentJson(state) {
            state.documentJson = initialState.documentJson;
        },
        resetDocumentStreaming(state) {
            state.streaming = initialState.streaming;
        },
        resetSelectedFileIds(state) {
            state.selectedFileIds = initialState.selectedFileIds;
        },
        resetShareState(state) {
            state.shareState = initialState.shareState;
        },
        resetNote(state) {
            state.note = initialState.note;
        },
        resetStreaming(state) {
            state.streaming = initialState.streaming;
        },
        setWebUrl(state, { payload }) {
            state.webUrl = payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(exports.fetchMyDocuments.fulfilled, (state, { payload }) => {
            if (payload && !(payload instanceof error_1.RequestError)) {
                state.wasDocumentsFetched = true;
                documentsAdapter.setAll(state, payload);
            }
        });
    },
});
exports.fetchMyDocuments = (0, toolkit_1.createAsyncThunk)('document/fetchDocuments', () => ((0, document_1.getMyDocuments)()));
exports.shareDocument = (0, toolkit_1.createAsyncThunk)('document/shareDocument', async ({ document, password }, { dispatch }) => {
    const conversationId = ('conversation' in document ? document.conversation.id : document.conversationId);
    const shareLink = await (0, document_1.getShareLink)(conversationId, document.files?.map((file) => file.id)
        || ('fileId' in document && document.fileId ? [document.fileId] : ['']), password);
    if (shareLink instanceof Error) {
        throw shareLink;
    }
    ;
    dispatch((0, exports.setDocumentShareState)({
        isSharing: true,
        shareUrl: shareLink.url,
        documentId: 'character' in document ? document.character.id : document.character_id,
        sharedConversationId: conversationId,
        sharedFileIds: document.files?.map((file) => file.id)
            || ('fileId' in document && document.fileId ? [document.fileId] : ['']),
        sharingType: 'owner',
        isPasswordSet: shareLink.isPasswordSet === 'Y',
    }));
});
const { selectIds, selectById } = documentsAdapter.getSelectors();
function selectWasDocumentsFetched(state) {
    return state.documents.wasDocumentsFetched;
}
;
function selectMyDocumentsIds(state) {
    return selectIds(state.documents);
}
;
function selectDocumentById(state, documentId) {
    return selectById(state.documents, documentId);
}
;
function selectLastDocument(state) {
    return state.documents.entities[state.documents.ids[0]];
}
;
function selectDocumentsQuantity(state) {
    return selectMyDocumentsIds(state).length;
}
;
function selectDocumentsEntities(state) {
    return state.documents.entities;
}
_a = exports.documentSlice.actions, exports.setDocumentSummary = _a.setDocumentSummary, exports.setDocumentJson = _a.setDocumentJson, exports.setSelectedFileIds = _a.setSelectedFileIds, exports.setNote = _a.setNote, exports.setDocumentStreaming = _a.setDocumentStreaming, exports.setDocumentUploadComplete = _a.setDocumentUploadComplete, exports.setDocumentShareState = _a.setDocumentShareState, exports.setIsDocumentSharing = _a.setIsDocumentSharing, exports.setDocumentSharingType = _a.setDocumentSharingType, exports.setIsLoading = _a.setIsLoading, exports.setIsImageRegenerating = _a.setIsImageRegenerating, exports.setIsConversationOpen = _a.setIsConversationOpen, exports.setIsSourcesOpen = _a.setIsSourcesOpen, exports.setIsAudioConfigOpen = _a.setIsAudioConfigOpen, exports.addDocument = _a.addDocument, exports.addDocumentSourcesLoading = _a.addDocumentSourcesLoading, exports.patchDocument = _a.patchDocument, exports.patchDocumentCharacter = _a.patchDocumentCharacter, exports.patchDocumentConversation = _a.patchDocumentConversation, exports.patchDocumentSummary = _a.patchDocumentSummary, exports.patchDocumentJson = _a.patchDocumentJson, exports.patchLatestDocumentCharacter = _a.patchLatestDocumentCharacter, exports.deleteDocument = _a.deleteDocument, exports.deleteDocumentSourcesLoading = _a.deleteDocumentSourcesLoading, exports.upsertDocumentJson = _a.upsertDocumentJson, exports.selectFiles = _a.selectFiles, exports.unSelectedFile = _a.unSelectedFile, exports.toggleDocumentConversationOpen = _a.toggleDocumentConversationOpen, exports.toggleSourcesOpen = _a.toggleSourcesOpen, exports.toggleAudioConfigOpen = _a.toggleAudioConfigOpen, exports.togglePdfOpen = _a.togglePdfOpen, exports.closeDocumentPanels = _a.closeDocumentPanels, exports.resetDocuments = _a.resetDocuments, exports.resetDocumentSummary = _a.resetDocumentSummary, exports.resetDocumentJson = _a.resetDocumentJson, exports.resetDocumentStreaming = _a.resetDocumentStreaming, exports.resetSelectedFileIds = _a.resetSelectedFileIds, exports.resetShareState = _a.resetShareState, exports.resetNote = _a.resetNote, exports.resetStreaming = _a.resetStreaming;
exports.default = exports.documentSlice;
